module.exports = __webpack_public_path__ + "img/rocket-silo.cd0b8acb.png";